import { FeatureRequest, CreateFeatureRequest } from "types";
import { api } from "./base.api";

export const featureAPI = {
  createFeature: async (feature: CreateFeatureRequest) => {
    const response = await api.post("/features", feature);
    return response.data;
  },

  getFeatures: async () => {
    const response = await api.get("/features");
    console.log("getFeatures response", response);
    return response.data;
  },
  getPublicFeatures: async () => {
    const response = await api.get("/features/public");
    console.log("getFeatures response", response);
    return response.data;
  },

  getFeature: async (id: string) => {
    const response = await api.get(`/features/${id}`);
    return response.data;
  },

  updateFeature: async (id: string, feature: Partial<FeatureRequest>) => {
    const response = await api.patch(`/features/${id}`, feature);
    return response.data;
  },

  vote: async (id: string) => {
    const response = await api.post(`/features/${id}/vote`);
    return response.data;
  },

  removeVote: async (id: string) => {
    const response = await api.delete(`/features/${id}/vote`);
    return response.data;
  },

  getUserVotes: async () => {
    const response = await api.get("/features/my-votes");
    return response.data;
  },
};
